import { render, staticRenderFns } from "./MessageTemplateForm.vue?vue&type=template&id=7baabd40&"
import script from "./MessageTemplateForm.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports